export function useIsActivityAddOnAvailable () {
  function isActivityAddOnAvailable (activityAddOn) {
    return activityAddOn.isActive
  }

  return {
    isActivityAddOnAvailable
  }
}
